import { Context, Effect } from "effect";
import type { ResourceFailure } from "@workerstation/shared/errors/resource";
import type { R2Binding, R2Download, R2Target } from "./model.ts";

export interface R2ApiShape {
  readonly bindings: (workspaceId: string) => Effect.Effect<readonly R2Binding[], ResourceFailure>;
  readonly upload: (target: R2Target, key: string, body: Blob) => Effect.Effect<void, ResourceFailure>;
  readonly delete: (target: R2Target, key: string) => Effect.Effect<void, ResourceFailure>;
  readonly download: (target: R2Target, key: string) => Effect.Effect<R2Download, ResourceFailure>;
}
export class R2Api extends Context.Service<R2Api, R2ApiShape>()("workerstation/frontend/R2Api") {}
